import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'whatwg-fetch';
import SubNavBar from '../SubNavBar';
import withAuth from 'src/hoc/withAuth';

const apiSupplierHardwareShow = '/api/stepSupplierion/getSupplierHardware/';
const apiSupplierVirtualShow = '/api/stepSupplierion/getSupplierVirtual/';
const linkToTicket = '/dashboard/ticket/';

class DisplaySupplier extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalPostCustomerOpen: false,
      entity: undefined,
      isHardware: undefined,
      supplierName: '____',
      supplierSinceDate: '____',
      supplierTickets: undefined,
      extendedTickets: false,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  toggleTickets() {
    this.setState({
      extendedTickets: !this.state.extendedTickets,
    });
  }

  componentDidMount() {
    if (this.props.supplierType && this.props.match.params.id) {
      // check if id supplied in the route
      let isHardware = this.props.supplierType == 'hardware';
      let queryURL = isHardware ? apiSupplierHardwareShow : apiSupplierVirtualShow;

      let supplierId = this.props.match.params.id;

      let graphQL = '{ supplier(id:' + supplierId + '){ id, name, dateCreate, tickets{ id, subject, dateCreate } } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['supplier']) {
              this.setState({
                isHardware: isHardware,
                supplierName: data['data']['supplier']['name'],
                supplierSinceDate: data['data']['supplier']['dateCreate'],
                supplierTickets: data['data']['supplier']['tickets'].reverse(),
              });
            }
            //console.log(data);
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log('erreur fetch Supplier entity: \n' + error);
          }.bind(this)
        );
    }
    ///////////////////////////////////////
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id != this.props.match.params.id) {
      // Route reloaded
      this.componentDidMount();
    }
  }

  render() {
    const { supplierTickets } = this.state;

    let noSupplierTicket = '';
    if (this.state.supplierTickets != undefined && this.state.supplierTickets.length == 0) {
      noSupplierTicket = <span>Aucun ticket pour ce fournisseur.</span>;
    }

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar goBack={this.props.history.goBack} title='Fiche Fournisseur' />

        <div id='appViewContent'>
          <div className='entity-display'>
            <form>
              <div className='form-group'>
                <label htmlFor='inputName'>Nom</label>
                <input
                  name='supplierName'
                  value={this.state.supplierName}
                  onChange={this.handleInputChange}
                  type='text'
                  className='form-control'
                  id='inputName'
                  placeholder='Nom du contact'
                  readOnly
                />
              </div>
              <div className='form-group'>
                <label htmlFor='inputName'>Type</label>
                <input
                  name='supplierType'
                  value={this.state.isHardware ? 'Matériel' : 'Virtuel'}
                  onChange={this.handleInputChange}
                  type='text'
                  className='form-control'
                  id='inputName'
                  placeholder='Nom du contact'
                  readOnly
                />
              </div>
              <div className='form-group'>
                <label htmlFor='inputName'>Depuis le</label>
                <input
                  name='supplierSinceDate'
                  value={this.state.supplierSinceDate}
                  onChange={this.handleInputChange}
                  type='text'
                  className='form-control'
                  id='inputName'
                  placeholder='Nom du contact'
                  readOnly
                />
              </div>
            </form>

            <div className='alignHorizontal'>
              <h3>
                Tickets ({this.state.supplierTickets ? this.state.supplierTickets.length : '_'}
                ):
              </h3>
              <button onClick={this.toggleTickets} type='button' className='btn btn-sm btn-outline-success'>
                <span
                  className={
                    'icon ' + (this.state.extendedTickets ? 'icon-chevron-thin-up ' : 'icon-chevron-thin-down ')
                  }
                ></span>
              </button>
            </div>
            {this.state.extendedTickets &&
              (supplierTickets ? (
                supplierTickets.map((data) => (
                  <li className='list-group-item entity-row' key={data.id}>
                    <Link to={linkToTicket + data.id}>
                      <span>{data.subject}</span>
                    </Link>
                    <span>{moment(data.dateCreate).format('DD-MM-YY')}</span>
                  </li>
                ))
              ) : (
                <li className='list-group-item'>Chargement...</li>
              ))}
            {this.state.extendedTickets && noSupplierTicket}
          </div>
        </div>
      </div>
    );
  }
}

export default withAuth(DisplaySupplier);
